<template>
  <div>

    <div>
      <b-table
        striped
        hover
        responsive
        class="holiday-data-table"
        style="white-space: nowrap"
        :items="items"
        :fields="fields">
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.key === 'actions' ? '10%' : '' }" />
        </template>
        <template #cell(date)="data">
          <div>
            {{ new Date(Date.parse(data.item.start_date)).toLocaleString('id-ID', { weekday: 'long', day: 'numeric', month: 'numeric', year: 'numeric' }).replaceAll('/', '-') }}
            <span v-if="data.item.end_date != ''"> <b>s/d</b> {{ new Date(Date.parse(data.item.end_date)).toLocaleString('id-ID', { weekday: 'long', day: 'numeric', month: 'numeric', year: 'numeric' }).replaceAll('/', '-') }}</span>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-button
            size="sm"
            class="mr-1 btn-success"
            v-b-tooltip.hover
            title="Edit"
            @click="btnEditOnClick(data.item.id)"
            v-b-modal.modal-form
            v-if="manipulateBtn == true"><i class="fas fa-edit px-0"></i></b-button>
          <b-button
            size="sm"
            class="btn-danger"
            v-b-tooltip.hover
            title="Hapus"
            v-if="manipulateBtn == true"
            @click="btnDeleteOnClick(data.item.id)"><i class="fas fa-trash px-0"></i></b-button>
        </template>
      </b-table>
      <data-table-pagination
        v-if="items.length != 0"
        :page="currentPage"
        :total-rows="totalRows"
        :per-page="perPage || 20"
        @change="pageOnClick" />
    </div>

  </div>
</template>

<script>

import DataTablePagination from '@/component/common/DataTablePagination.vue'

export default {

  components: {
    DataTablePagination
  },

  props: {
    fields: Array,
    items: Array,
    hasDoctor: Boolean,
    perPage: Number,
    currentPage: Number,
    totalRows: Number
  },

  data() {
    return {
      manipulateBtn: false,
    }
  },

  methods: {

    pageOnClick(page) {
      this.$emit('pageOnClick', page)
    },

    btnEditOnClick(id) {
      this.$emit('btnEditOnClick', id)
    },

    btnDeleteOnClick(id) {
      this.$emit('btnDeleteOnClick', id)
    },

    // access management
    async setActiveMenu() {

      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {


        if (access_right[a] == "4004") {
          this.manipulateBtn = true
        }

      }
    },

  },

  mounted() {
    this.setActiveMenu()
  }

}
</script>

<style lang="scss" scoped>
.holiday-data-table {
  margin: 0;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .holiday-data-table table { margin-bottom: 0; }
::v-deep .holiday-data-table thead th { border-top: 0; background: #f8fafc; }
</style>
